import { useDispatch } from "react-redux";
import { actions as notificationActions } from "reducers/notification";
import * as i18n from "util/i18n";

export const useCopyToClipBoard = (isDesktop, i18nId, i18nParams) => {
    const dispatch = useDispatch();
    const textCopy = i18n.get(i18nId, null, i18nParams);

    const handleCopyToClipBoard = async (scope) => {
        if (!isDesktop && window.cordova) {
            const options = {
                message: textCopy,
            };
            window.plugins.socialsharing.shareWithOptions(options, null, null);
        } else {
            try {
                await navigator.clipboard.writeText(textCopy);
            } finally {
                dispatch(notificationActions.showNotification(i18n.get("general.copyData"), "success", [scope]));
            }
        }
    };

    return { dispatch, handleCopyToClipBoard };
};

export default useCopyToClipBoard;
